import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { PublicBoxQuestionnaireQuestionOptionResponse } from './public-box-questionnaire-question-option.response';

@jsonObject
export class PublicBoxQuestionnaireQuestionResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly description?: Nillable<string>;

  @jsonArrayMember(PublicBoxQuestionnaireQuestionOptionResponse)
  public readonly options!: PublicBoxQuestionnaireQuestionOptionResponse[];
}
